import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H3V6h18v12zm-6.5-7L11 15.51 8.5 12.5 5 17h14z"
}), 'PanoramaOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PanoramaOutlined.js
// module id = 5197
// module chunks = 2